import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import SessionStorage from 'libs/SessionStorage';
import { ConfirmEmail } from 'modules/Account';
import { LogoLayout } from 'modules/Layout';
import OidcService from 'services/OidcService';
async function action({ route, query, getUrl }, params) {
    const returnUrl = query.ReturnUrl;
    const { countryCode, token } = params;
    let redirect = null;
    if (process.env.BROWSER) {
        const user = await OidcService.getUser();
        if (!user) {
            if (!returnUrl) {
                SessionStorage.setItem('confirmCountryCode', countryCode);
                SessionStorage.setItem('confirmToken', token);
            }
        } else {
            redirect = getUrl('app-catalog');
        }
    }
    return {
        chunks: [
            'account'
        ],
        name: route.name,
        redirect,
        component: /*#__PURE__*/ _jsx(LogoLayout, {
            children: /*#__PURE__*/ _jsx(ConfirmEmail, {
                countryCode: countryCode,
                token: token,
                returnUrl: returnUrl
            })
        })
    };
}
export default action;
